import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_CLIENT_PROTECTION_ADMIN_ACTION_TYPE } from '../actions';

const initialState = {
  policy: null,
};

const commandCenterClientProtectionAdminReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_CLIENT_PROTECTION_ADMIN_ACTION_TYPE.SET_CLIENT_PROTECTION:
        draft.policy = payload;
        break;

      case RESET_STATE:
      case COMMAND_CENTER_CLIENT_PROTECTION_ADMIN_ACTION_TYPE.RESET_CLIENT_PROTECTION_STATE:
        return initialState;

      default:
        break;
    }
  });

export default commandCenterClientProtectionAdminReducer;
